// Autopilot: lista kampanii, dialog trzech kroków, szczegół, pozycje (paczka 12,
// artboardy 05–09 i 11–14). Klucze trzymaj zgodne z en/appCampaigns.ts.
//
// Rama copy: planowanie publikacji na własnych kontach przez oficjalny dostęp
// platformy. Panel niczego nie obiecuje o tym, co stanie się z postem po publikacji;
// nazwa protokołu logowania ani słowo o interfejsie programistycznym nie padają.
//
// Adresy techniczne z dawnym słownictwem ZOSTAJĄ (to adresy, nie copy): `autopilot.batchSub`,
// czwarty klucz bloku `planError`. Zmiana adresu wywraca `check_locale_keys.py`.
import { appCampaignsK45 } from './appCampaigns.k45'
import { appCampaignsH45 } from './appCampaigns.h45'
import { appCampaignsP45 } from './appCampaigns.p45'

export const appCampaigns = {
  // Pasek = sam tytuł (sesja 20, decyzja 2): zdanie o zgodzie znika na polecenie Domiego,
  // a „Planowanie publikacji na Twoich kontach.” powtarzało to, co mówi stan pusty.
  topbar: {
    title: 'Autopilot',
  },
  // Pas kont nad treścią (sesja 20, decyzja 3): etykieta z `appAccounts.title`,
  // a to zdanie stoi zamiast chipów, kiedy nie ma jeszcze żadnego konta.
  accounts: {
    none: 'Żadne konto nie jest jeszcze podłączone.',
    // Chip konta (sesja 20 R2): ile postów wyszło DZIŚ z dziennego limitu — z `/api/publishing/summary`.
    today: '{n} / {cap} dziś',
  },
  // Jedno zdanie nad listą pozycji, gdy publikowanie jest chwilowo niedostępne —
  // bez banera i bez pigułki (artboard 14).
  banner: {
    blockedSub: 'Publikowanie chwilowo niedostępne - plan możesz przygotować i zapisać, ruszy, kiedy publikowanie wróci.',
  },
  // Stan „czeka” (artboard 01 B): bez obietnicy, bez daty, bez przycisku.
  disabled: {
    title: 'Autopilot nie jest jeszcze włączony na tym koncie',
  },
  empty: {
    liveTitle: 'Nie masz jeszcze kampanii',
    liveBody: 'Autopilot rozłoży gotowe edity z Twoich serii na Twoje konta.',
    // Droga z kafla serii bez gotowych editów (artboard 05).
    generator: 'Generuj edity',
  },
  loading2: 'Wczytujemy kampanie…',
  title: 'Autopilot',
  error: 'Nie udało się wczytać Twoich kampanii.',
  // Odpowiedź na DZIAŁANIE, nie status pozycji. Serwer odmawia ponowienia postu,
  // którego gemy są wciąż wstrzymane po nieudanym wycofaniu (P02, `4584412`:
  // FAILED + refunded_at IS NULL → 409). Bez tego tekstu artysta dostaje fallback
  // `error` i klika drugi raz — czyli robi dokładnie to, przed czym ta odmowa go
  // chroni. Zdanie mówi najpierw o duplikacie, a dopiero potem o gemach.
  apiError: {
    // Odmowa, ktora znaczy „POCZEKAJ", a nie „cos poszlo nie tak" (`campaigns/routes.py:396`).
    still_in_flight:
      'Ten post jest jeszcze u platformy. Poczekaj, aż się zakończy - dopiero wtedy można spróbować ponownie.',
    gems_on_hold:
      'Nie możemy tego ponowić - tamten post został już przekazany i może być na Twoim koncie, więc ponowienie dołożyłoby drugi. Tokeny wstrzymane do wyjaśnienia; odezwiemy się.',
    // BLIŹNIAK: `errors.pl.already_published` niesie krótszą wersję tego samego kodu dla
    // powierzchni ogólnych. Jeden klucz na DWIE odmowy (`cancel_item` i `retry_item`).
    already_published:
      'Ten post już się opublikował - nie trzeba go ponawiać i nie da się go już usunąć z planu.',
  },
  status: {
    draft: 'szkic',
    scheduled: 'zaplanowana',
    running: 'w trakcie',
    paused: 'wstrzymana',
    completed: 'zakończona',
    cancelled: 'anulowana',
    failed: 'nieudana',
  },
  // Stan POZYCJI (jednego posta), nie kampanii. Osobny blok od `status`, bo to osobny
  // enum po stronie serwera (osiem wartości wobec siedmiu) i inny rodzaj gramatyczny.
  itemStatus: {
    planned: 'w planie',
    queued: 'w kolejce',
    scheduled: 'zaplanowany',
    publishing: 'wychodzi',
    published: 'opublikowany',
    failed: 'nieudany',
    cancelled: 'anulowany',
    skipped: 'pominięty',
  },
  // Faza jednego posta (`CampaignDetail.phaseOf`): to, co niesie pigułka wiersza.
  job: {
    published: 'opublikowany',
    sending: 'wychodzi',
    scheduled: 'zaplanowany',
    failed: 'nieudany',
    cancelled: 'anulowany',
    awaiting: 'czeka na zgodę',
    held: 'wstrzymany',
  },
  // Jedna linia liczb nad listą: tylko liczby, które zmieniają decyzję (G7-account-token2-08).
  // Baza = forma `many`; wołać przez `_` + pluralForm().
  stats: {
    accounts: '{n} kont',
    accounts_one: '{n} konto',
    accounts_few: '{n} konta',
    accounts_many: '{n} kont',
    ready: '{n} editów gotowych',
    ready_one: '{n} edit gotowy',
    ready_few: '{n} edity gotowe',
    ready_many: '{n} editów gotowych',
    edits: '{n} editów',
    edits_one: '{n} edit',
    edits_few: '{n} edity',
    edits_many: '{n} editów',
  },
  list: {
    label: 'Lista kampanii',
    // Etykieta kafla Pulpitu (artboard 15) — ten sam klucz, nie druga kopia.
    scheduled: 'Zaplanowane',
    // Karty, nie wiersze (sesja 20, decyzja 4): nagłówka kolumn nie ma, więc nie ma
    // `thName/thMode/thStatus/thNext`. Kampania z postami bez zgody dostaje zamiast
    // pigułki „Szkic” pigułkę `awaitingPill` i JEDYNY przycisk listy (`approve`);
    // `open` jest etykietą karty-linku dla czytnika ekranu.
    awaitingPill: 'Czeka na zgody',
    approve: 'Zatwierdź posty',
    open: 'Otwórz kampanię',
    next: 'następny {when}',
    // Sesja 20 R2: konto następnego posta jest znane (`next_connection_id`).
    nextOn: 'następny {when} · {handle}',
    // Rząd kadrów pierwszych 4 postów (etykieta listy) i kafel „+N” dla czytnika ekranu.
    frames: 'Pierwsze posty kampanii',
    morePosts: 'jeszcze {n} postów',
    morePosts_one: 'jeszcze {n} post',
    morePosts_few: 'jeszcze {n} posty',
    morePosts_many: 'jeszcze {n} postów',
    awaitingConsents: 'czeka na {n} zgód',
    awaitingConsents_one: 'czeka na {n} zgodę',
    awaitingConsents_few: 'czeka na {n} zgody',
    awaitingConsents_many: 'czeka na {n} zgód',
    // „wstrzymana 6 wrz” / „zakończona 31 sie” / „anulowana 14 lip” — stan słowem z `status.*`
    // w formie małej litery + data.
    endedAt: '{status} {date}',
    failedRefunded: '{n} postów nie wyszło · tokeny wróciły',
    failedRefunded_one: '{n} post nie wyszedł · tokeny wróciły',
    failedRefunded_few: '{n} posty nie wyszły · tokeny wróciły',
    failedRefunded_many: '{n} postów nie wyszło · tokeny wróciły',
  },
  // Tryb kampanii słowem z locale (decyzja 5 MAPA 12): kampania założona poza
  // Autopilotem jest „Ręczna”, nie „Manual”.
  mode: {
    manual: 'Ręczna',
    autopilot: 'Autopilot',
  },
  fields: {
    start: 'Start',
    end: 'Koniec',
  },
  captions: {
    title: 'Opisy postów',
    pack: 'Paczka opisów',
    none: 'Bez paczki - wpiszę opisy przy zatwierdzaniu',
    hint: 'Jedna paczka dla całej serii publikacji. Gotowe opisy zobaczysz w planie.',
    nick: 'Nick artysty',
    nickHint: '{@nick} to profil do oznaczenia, np. @dominik. Wpisz raz dla całej serii publikacji.',
    nickRequired: 'Wpisz nick artysty dla wybranej paczki opisów.',
    nickInvalid: 'Wpisz nick bez spacji: litery, cyfry, kropki lub podkreślenia (do 64 znaków).',
    loadError: 'Nie udało się wczytać paczek opisów.',
    valuesError: 'Uzupełnij lub popraw zmienne wybranej paczki opisów.',
    change: 'Popraw opisy',
    caption: 'Opis posta',
    planChanged: 'Paczka opisów zmieniła się od podglądu. Odśwież plan i sprawdź nowe opisy przed zapisaniem.',
    refreshPlan: 'Odśwież plan',
    // Paczka bez opisów stoi na liście wyłączona (meta w mono), a pod polem jest droga do Biblioteki.
    emptyPack: '0 opisów',
    emptyPacks: 'Paczki bez opisów nie da się wybrać: {names}.',
    fillInLibrary: 'Dodaj opisy w Bibliotece',
    // Reguła 33: pole zmiennej, której używa WYBRANA paczka. Etykiety tylko dla
    // zmiennych, które zna dzisiejszy parser (`lib/textTemplates.ts`).
    valueRequired: 'Wpisz wartość.',
    vars: {
      artist: 'Artysta',
      nick: 'Nick artysty',
      timestamp: 'Moment',
      title: 'Tytuł utworu',
    },
  },
  // Krok 1: serie. Seria wchodzi w całości; pojedyncze edity wyłącza się w panelu.
  pick: {
    edits: 'Wybierz serie',
    seriesHint: 'Seria wchodzi w całości - pojedyncze edity wyłączysz po kliknięciu „edity serii”.',
    selectedSeries: 'serie wybrane',
    all: 'wszystkie',
    none: 'żadna',
    noneAccounts: 'żadne',
    clear: 'wyczyść',
    seriesEdits: 'edity serii',
    summary: 'Wybrane {n} serii',
    summary_one: 'Wybrana {n} seria',
    summary_few: 'Wybrane {n} serie',
    summary_many: 'Wybrane {n} serii',
    accounts: 'Konta',
    selectedAccounts: '{n} z {total} kont',
    selectedAccounts_one: '{n} z {total} konta',
    selectedAccounts_few: '{n} z {total} kont',
    selectedAccounts_many: '{n} z {total} kont',
    noAccounts: 'Najpierw podłącz konto.',
    noSeries: 'Nie masz jeszcze serii z gotowymi editami.',
    // Powód wyłączonego „Dalej” w kroku 1 (nic nie zaznaczono) — na ekranie, nie w `title`.
    pickOne: 'Wybierz co najmniej jedną serię.',
    allSeries: 'Wszystkie ({n})',
    searchSeries: 'Szukaj serii…',
  },
  // Kafel serii i panel jej editów (artboardy 05–06).
  series: {
    ready: '{n} editów · gotowe',
    ready_one: '{n} edit · gotowy',
    ready_few: '{n} edity · gotowe',
    ready_many: '{n} editów · gotowe',
    partial: 'gotowe {n} z {total} · w toku',
    none: '0 gotowych - poczekaj na render',
    rendering: 'Renderuje się',
    readyOf: '{n} z {total} gotowych',
    editsTitle: 'Edity serii „{name}”',
    selectedEdits: '{n} z {total} wybranych',
    notSelectable: 'nie do wyboru',
    // Reguła 30: trzy słowa stanu renderu. Seria niedokończona jest „w kolejce”.
    queued: 'w kolejce',
    done: 'Gotowe',
    untitled: 'Seria bez nazwy',
    editName: 'edit {n}',
  },
  // Krok 2: okno publikacji. Podpisy pól z kodu (2 h wyprzedzenia, 5 dni), jedno
  // zdanie reguł dyspozytora pod polami — bez ramki i bez słowa „Zaawansowane”.
  window: {
    title: 'Okno publikacji',
    hint: 'Autopilot rozkłada {n} postów między start a koniec.',
    hint_one: 'Autopilot rozkłada {n} post między start a koniec.',
    hint_few: 'Autopilot rozkłada {n} posty między start a koniec.',
    hint_many: 'Autopilot rozkłada {n} postów między start a koniec.',
    startHint: 'za 2 h - najwcześniej, jak się da',
    endHint: 'za 5 dni - możesz zmienić',
  },
  // Autopilot układa plan; sam z siebie NIC nie publikuje — zgoda per post jest
  // osobnym, następnym krokiem i `footNote` mówi to na ekranie.
  autopilot: {
    title: 'Autopilot',
    sub: 'Planowanie publikacji na Twoich kontach przez oficjalny dostęp platformy. Nic nie wyjdzie bez Twojej zgody na każdy post.',
    stepsLabel: 'Kroki Autopilota',
    steps: {
      series: 'Serie',
      accounts: 'Konta i okno',
      plan: 'Plan i koszt',
    },
    // Adres techniczny (dawne słowo); nieużyty w interfejsie, zostaje jako adres.
    batchSub: 'Gotowe edity: {edits} · Połączone konta: {accounts}',
    previewTitle: 'Tak to wypadnie',
    previewCount: 'Posty: {posts} · Dni: {days}',
    previewFits: 'Posty: {fits} z {posts} · Dni: {days}',
    advancedSub: 'Posty wychodzą między 9:00 a 22:00, najwyżej 5 dziennie na konto, co najmniej godzinę od siebie · {tz}',
    nextAccounts: 'Dalej - konta i okno',
    nextPlan: 'Dalej - plan i koszt',
    next: 'Przejrzyj i zatwierdź {n} postów',
    next_one: 'Przejrzyj i zatwierdź {n} post',
    next_few: 'Przejrzyj i zatwierdź {n} posty',
    next_many: 'Przejrzyj i zatwierdź {n} postów',
    draftName: 'Szkic „{name}” - nazwę nadajemy z serii i daty. Zmiana okna przelicza plan.',
    costRow: '{n} postów × {each} tokeny',
    costRow_one: '{n} post × {each} tokeny',
    costRow_few: '{n} posty × {each} tokeny',
    costRow_many: '{n} postów × {each} tokeny',
    costTotal: '{n} tokenów',
    costTotal_one: '{n} token',
    costTotal_few: '{n} tokeny',
    costTotal_many: '{n} tokenów',
    balanceRow: 'Saldo {before} → {after}',
    balanceLabel: 'Saldo',
    refundNote: 'Za każdy post, który nie wyjdzie, tokeny wracają automatycznie.',
    notEnoughGems: 'Nie masz tylu tokenów, ile wymaga ten plan - potrzeba {need}, masz {have}.',
    fewerEdits: 'albo wybierz mniej editów',
    extendTo: 'Wydłuż do {date}',
    footNote: 'Następny krok to zgoda na każdy post - nic nie wyjdzie wcześniej.',
    planning: 'Układamy plan…',
  },
  // Planer publikacji (sesja 22, artboardy 01–03): cztery wiersze kroków jak w generatorze
  // i prawy pasek z podglądem kalendarza. Treść samych kroków (serie, opisy, okno, konta)
  // to te same klucze, co dotąd — zmienił się układ, nie słownictwo.
  // ── paczka PF (35-R5): krok „Konta" z podzialem puli ───────────────────────
  // Regula 55: liczba przy koncie, suma jako dana, jeden edit = jedno konto. Zadne
  // z tych slow nie tlumaczy — kazde nazywa liczbe, ktora stoi obok.
  split: {
    title: 'Konta',
    cap: 'najwyżej {n}',
    pickEdits: 'Wybierz edity',
    given: 'Rozdane',
    even: 'po równo',
    custom: 'własny',
    of: '{n} / {total}',
    // Skrót wiersza kroku 3 („3 konta · 8 · 8 · 8"): liczba rządzi rzeczownikiem.
    accountsN: '{n} kont',
    accountsN_one: '{n} konto',
    accountsN_few: '{n} konta',
    accountsN_many: '{n} kont',
    doneN: 'Gotowe · {n} editów',
    doneN_one: 'Gotowe · {n} edit',
    doneN_few: 'Gotowe · {n} edity',
    doneN_many: 'Gotowe · {n} editów',
    editsFor: 'Edity dla {handle}',
    chosen: 'wybrane',
    // Nazwa dla czytnika na kadrze, ktory nalezy juz do innego konta.
    assignedTo: 'przypisany do {handle}',
  },
  // ── paczka PF (35-R5): krok „Harmonogram" ──────────────────────────────────
  // Regula 54: kazdy sufit serwera jest ZAKRESEM kontrolki („od 12:40", „3 / 5",
  // szara pigulka odstepu), nigdy zdaniem pod polem ani bledem po fakcie.
  schedule: {
    title: 'Harmonogram',
    start: 'Start',
    end: 'Koniec',
    doneN: 'Gotowe · {n} postów',
    doneN_one: 'Gotowe · {n} post',
    doneN_few: 'Gotowe · {n} posty',
    doneN_many: 'Gotowe · {n} postów',
  },
  // ── paczka PF (35-R5), od 44-R2 A (paczka PA): liczby nagłówka arkusza sceny Planera ─
  rail: {
    posts: 'Posty',
    accounts: 'Konta',
    days: 'Dni',
    skipped: 'pominięte pary',
    show: 'Pokaż',
    open: 'Pokaż plan',
    schedule: 'Zaplanuj',
    lack: 'Brakuje',
    topUp: 'Doładuj tokeny',
  },
  // ── sekcja G (paczka PA): edity puli już zaplanowane / opublikowane — dana + „Pomiń” ──
  pool: {
    alreadyPublished_one: '{n} już opublikowany',
    alreadyPublished_few: '{n} już opublikowane',
    alreadyPublished_many: '{n} już opublikowanych',
    alreadyScheduled_one: '{n} już zaplanowany',
    alreadyScheduled_few: '{n} już zaplanowane',
    alreadyScheduled_many: '{n} już zaplanowanych',
    skipUsed: 'Pomiń',
  },
  // ── paczka PA (44-R2 A): Planer jako scena miesiąca, formularz = arkusz sceny ──
  stage: {
    newPlan: 'Nowy plan',
    // Szewron nagłówka arkusza (czytnik): nazwa DRUGIEJ wysokości.
    showMonth: 'Pokaż cały miesiąc',
    showForm: 'Pokaż formularz',
    // Nazwa komórki dnia z pierścieniami (czytnik).
    dayInPlan: 'w planie {n}',
    collapseStep: 'Zwiń krok {step}',
    // Toast faktu po „Zaplanuj” (plan utworzony, zgoda per post zapisana, plan uruchomiony).
    scheduled: 'Zaplanowano {n} postów.',
    scheduled_one: 'Zaplanowano {n} post.',
    scheduled_few: 'Zaplanowano {n} posty.',
    scheduled_many: 'Zaplanowano {n} postów.',
    // Linia narzędzi pod krokami: podgląd na życzenie (nigdy obowiązkowy).
    preview: 'Podgląd',
    previewN: 'Podgląd · {n} postów',
    previewN_one: 'Podgląd · {n} post',
    previewN_few: 'Podgląd · {n} posty',
    previewN_many: 'Podgląd · {n} postów',
    clear: 'Wyczyść',
  },
  // ── paczka PF (35-R5): wstazka stanow planu (regula 56) ─────────────────────
  journey: {
    draft: 'Szkic',
    savedAt: 'zapisany {when}',
    consent: 'Zatwierdzenie treści',
    consentOf: '{n} / {total} · po {batch}',
    running: 'Uruchomiony',
    afterConsent: 'po zatwierdzeniu',
    waitsActivate: 'czeka na Uruchom',
    pausedAt: 'wstrzymany {when}',
    approveNext: 'Zatwierdź kolejne {n}',
  },
  planner: {
    // ── paczka 35a: wiersze kroków, karta podsumowania, pasek akcji 390 ──────────
    // Nazwy kroków idą z kluczy, które ekran już miał (`pick.edits`, `captions.pack`,
    // `pick.accounts`); trzeci krok dostaje własną nazwę, bo „Daty kampanii” mówiło
    // o kampanii, a wiersz pokazuje start i koniec okna.
    stepWindow: 'Start i koniec',
    // Jedna linia pod podglądem: ile postów i przez ile dni. Liczba nie rządzi
    // rzeczownikiem, więc bez rodziny liczby mnogiej.
    postsDays: 'Posty {n} · Dni {d}',
    // Plan, który nie mieści się w oknie: ile z ilu wchodzi (`window_too_small`).
    postsFit: 'Posty {n} z {total}',
    // Tabela karty podsumowania i okna „Ponowić post?”.
    cost: 'Koszt',
    have: 'Masz',
    left: 'Zostanie',
    missing: 'Brakuje',
    // Liczba, której jeszcze nie ma z czego policzyć, jest kreską, nie zerem.
    dash: '-',
    loadMore: 'Załaduj więcej',
    // Pigułki blokad (zasada 8: stan pokazuje kontrolka, nie zdanie).
    pill: {
      noEdits: 'brak gotowych editów',
      noAccount: 'brak konta',
      noValue: 'brak wartości zmiennej',
      paused: 'publikowanie wstrzymane',
      limitToday: 'limit na dziś',
      draft: 'szkic',
      missingTokens: 'brakuje {n} tokenów',
      missingTokens_one: 'brakuje {n} tokena',
      missingTokens_few: 'brakuje {n} tokenów',
      missingTokens_many: 'brakuje {n} tokenów',
      // Krok, który blokuje „Zaplanuj”, choć serwer nie zgłosił błędu: nic jeszcze
      // nie wybrano. Ta sama pigułka jest powodem, który czytnik słyszy przy przycisku.
      toPick: 'do wyboru',
      // Podglądu nie ma z czego policzyć: przeliczamy, podgląd jest nieaktualny, zero
      // postów albo serwer odmówił kodem, którego nie umiemy nazwać po imieniu.
      noPlan: 'brak planu',
      // Liczba gotowych editów serii w oknie wyboru (wiersz serii, która ich nie ma).
      readyEdits: '{n} gotowych',
    },
    // Akcja główna okna kroku: „Gotowe · {ile wybrano}”.
    done: {
      series: 'Gotowe · {n} serii',
      series_one: 'Gotowe · {n} seria',
      series_few: 'Gotowe · {n} serie',
      series_many: 'Gotowe · {n} serii',
      edits: 'Gotowe · {n} z {total}',
      pack: 'Gotowe · 1 paczka',
      noPack: 'Gotowe · bez paczki',
      days: 'Gotowe · {n} dni',
      days_one: 'Gotowe · {n} dzień',
      days_few: 'Gotowe · {n} dni',
      days_many: 'Gotowe · {n} dni',
      accounts: 'Gotowe · {n} kont',
      accounts_one: 'Gotowe · {n} konto',
      accounts_few: 'Gotowe · {n} konta',
      accounts_many: 'Gotowe · {n} kont',
      platforms: 'Gotowe · {n} platform',
      platforms_one: 'Gotowe · {n} platforma',
      platforms_few: 'Gotowe · {n} platformy',
      platforms_many: 'Gotowe · {n} platform',
    },
    // Droga naprawy przy pustej wartości zmiennej paczki opisów (reguła 33).
    fill: 'Uzupełnij',
    // 35-R5: pigulki i drogi stanow pustych, ktore zatrzymuja plan (R5-10, R5-11).
    noReadyEdits: 'brak gotowych editów',
    generate: 'Generuj edity',
    noAccount: 'brak konta',
    connect: 'Podłącz konto',
    // Roznica miedzy pula a tym, co rozdano wlasnym podzialem (R5-12) — DANA, nie zdanie.
    poolDiff: '{n} / {total}',
    // Akcja główna bez liczby: plan, którego nie ma jeszcze z czego policzyć (02a-02b).
    reviewAll: 'Przejrzyj i zatwierdź',
    // „Wstecz” z siatki editów serii do listy serii (okno 03b).
    back: 'Wstecz',
    steps: {
      edits: 'Edity',
      captions: 'Opisy',
      accounts: 'Konta',
      // 35-R5: czwarty krok to caly harmonogram (rytm, godziny, dni, koniec), a nie
      // dwie daty — stad nowa nazwa i nowe miejsce w kolejnosci.
      schedule: 'Harmonogram',
    },
    // Wiersze 3 i 4 czekają na wybór editów: to zdanie stoi zamiast podsumowania…
    afterEdits: 'po wyborze editów',
    noPack: 'Bez paczki',
    series: '{n} serii',
    series_one: '{n} seria',
    series_few: '{n} serie',
    series_many: '{n} serii',
    // „śr 16 wrz do pn 21 wrz” — słowo między datami okna w wierszu 3.
    to: 'do',
    preview: {
      title: 'Podgląd kalendarza',
      live: 'na żywo',
      updating: 'Aktualizujemy podgląd…',
      empty: 'Wybierz edity i daty - plan pojawi się tutaj.',
    },
    balance: 'Stan konta {before} · zostanie {after}',
    // Sesja 23 (artboard 04): znacznik przy serii w wierszu 1. Pułap 90 s jest NAJNIŻSZY
    // z trzech platform (Rolka), więc jedna liczba wystarcza na znacznik. To informacja,
    // nie błąd - taki edit dalej wyjdzie na konto TikToka albo YouTube.
    longEdits: '{n} editów > 90 s',
    longEdits_one: '{n} edit > 90 s',
    longEdits_few: '{n} edity > 90 s',
    longEdits_many: '{n} editów > 90 s',
    // Linia pod „Posty: n · Dni: d”: pary (edit, konto), których platforma konta nie
    // przyjmie. Osobne zdanie na każdy pułap, bo każde nazywa format tej platformy.
    skipped: '{n} editów pominiętych na {handle}: Rolka do 90 s',
    skipped_one: '{n} edit pominięty na {handle}: Rolka do 90 s',
    skipped_few: '{n} edity pominięte na {handle}: Rolka do 90 s',
    skipped_many: '{n} editów pominiętych na {handle}: Rolka do 90 s',
    skippedYt: '{n} editów pominiętych na {handle}: Short do 3 min',
    skippedYt_one: '{n} edit pominięty na {handle}: Short do 3 min',
    skippedYt_few: '{n} edity pominięte na {handle}: Short do 3 min',
    skippedYt_many: '{n} editów pominiętych na {handle}: Short do 3 min',
    skippedCap: '{n} editów pominiętych na {handle}: to konto przyjmuje do {max} s',
    skippedCap_one: '{n} edit pominięty na {handle}: to konto przyjmuje do {max} s',
    skippedCap_few: '{n} edity pominięte na {handle}: to konto przyjmuje do {max} s',
    skippedCap_many: '{n} editów pominiętych na {handle}: to konto przyjmuje do {max} s',
    skippedShort: '{n} editów pominiętych na {handle}: Rolka od {min} s',
    skippedShort_one: '{n} edit pominięty na {handle}: Rolka od {min} s',
    skippedShort_few: '{n} edity pominięte na {handle}: Rolka od {min} s',
    skippedShort_many: '{n} editów pominiętych na {handle}: Rolka od {min} s',
    // Podsumowanie wiersza 4: ile kont i NA JAKICH platformach („3 z 4 kont · TikTok,
    // Instagram, YouTube”); uchwyty stoją niżej, w chipach pasa wyboru.
    accountsSummary: '{n} z {total} kont · {platforms}',
    accountsSummary_one: '{n} z {total} konta · {platforms}',
    accountsSummary_few: '{n} z {total} kont · {platforms}',
    accountsSummary_many: '{n} z {total} kont · {platforms}',
  },
  // Dlaczego planu NIE dało się ułożyć. Osobno od `reason.*`, który mówi, co się
  // stało z gotowym postem.
  planError: {
    window_too_small: 'Okno jest za krótkie na wszystkie posty - mieści się {n}.',
    no_connected_accounts: 'Najpierw podłącz konto.',
    // Adres z dawnym słowem na serię ZOSTAJE (adres techniczny); zdanie jest o serii.
    empty_batch: 'Ta seria nie ma gotowych editów.',
    noReadyEdits: 'Ta seria nie ma gotowych editów.',
    unknown: 'Nie udało się zaplanować tej kampanii.',
    // Pułap platformy (Rolka 90 s, Short 3 min) odrzucił KAŻDY edit: „Ponów” nic nie zmieni.
    no_edits_fit_platforms: 'Żaden z wybranych editów nie mieści się w limicie długości wybranych kont (Rolka do 90 s, Short do 3 min).',
    changeAccounts: 'Zmień konta',
    // Droga przy `start_too_soon`: start skacze na najbliższą dopuszczalną minutę i plan liczy się od nowa.
    startSoonest: 'Ustaw start za 2 h',
  },
  // Nagłówek dnia w planie i w pozycjach (`DayGroup`).
  day: {
    posts: '{n} postów',
    posts_one: '{n} post',
    posts_few: '{n} posty',
    posts_many: '{n} postów',
  },
  detail: {
    // Liczba RZĄDZI rzeczownikiem, a `awaiting_consent` bywa 1 — więc trzy formy.
    awaiting: '{n} postów czeka na Twoje potwierdzenie',
    awaiting_one: '{n} post czeka na Twoje potwierdzenie',
    awaiting_few: '{n} posty czekają na Twoje potwierdzenie',
    awaiting_many: '{n} postów czeka na Twoje potwierdzenie',
    pause: 'Wstrzymaj',
    resume: 'Wznów',
    cancel: 'Anuluj kampanię',
    // Tytuł = pytanie z nazwą kampanii; treść = konsekwencje; wiersze z liczbami z backendu.
    cancelConfirm: 'Anulować kampanię „{name}”?',
    cancelBody: 'Posty, które jeszcze nie wyszły, zostaną zatrzymane. Opublikowane zostają na Twoich kontach.',
    cancelWillStop: 'Zatrzymane posty',
    cancelWillRefund: 'Tokeny wrócą do Twojej puli',
    resumeTitle: 'Wznowić kampanię?',
    resumeMissed: 'Pominięte posty: {n} - ich czas minął w trakcie wstrzymania, tokeny wróciły.',
    resumeRest: 'Pozostałe {n} postów wyjdzie według planu.',
    resumeRest_one: 'Pozostały {n} post wyjdzie według planu.',
    resumeRest_few: 'Pozostałe {n} posty wyjdą według planu.',
    resumeRest_many: 'Pozostałe {n} postów wyjdzie według planu.',
    resumeRefunded: 'Zwrócone tokeny',
    keep: 'Zostaw',
    keepPaused: 'Zostaw wstrzymaną',
    posts: 'Posty',
    filterAll: 'Wszystkie',
    filterAttention: 'Do naprawy',
    published: 'Opublikowane',
    reviewCta: 'Przejrzyj i potwierdź',
    progress: 'Postęp',
    progressOf: '{n} z {total} opublikowanych',
    limits: 'Limity kont',
    limitToday: '{n} / {max} dziś',
    limitsNote: 'Limit dzienny chroni konto - kolejne posty przejdą jutro.',
    // Kolumna zgód: czy dla każdego posta istnieje zapisana zgoda, kiedy i pod którą
    // wersją ekranu (`ui_version`). To jest widok tego, co obronimy przy audycie.
    consents: 'Zgody',
    consentsCollected: 'Zebrane',
    consentsOf: '{n} z {total}',
    consentsDate: 'Data',
    consentsVersion: 'Wersja zgody',
    consentsNote: 'Bez zapisanej zgody post nie zostanie wysłany - sprawdzamy to tuż przed wysyłką.',
    nothingToFix: 'Nic nie wymaga naprawy.',
    // Akcja wiersza postu czekającego na zgodę — inna niż zbiorcza „Przejrzyj i potwierdź”.
    confirmPost: 'Potwierdź post',
    // Okna 06a-06c: jedno zdanie z liczbą, bez drugiego zdania o zwrotach (zasada 8).
    cancelStops: '{n} zaplanowanych postów zostanie anulowanych.',
    cancelStops_one: '{n} zaplanowany post zostanie anulowany.',
    cancelStops_few: '{n} zaplanowane posty zostaną anulowane.',
    cancelStops_many: '{n} zaplanowanych postów zostanie anulowanych.',
    skippedPosts: 'Pominięte posty',
    postWillNotGo: 'Post nie wyjdzie.',
  },
  actions: {
    // Etykieta JEDYNEGO przycisku głównego panelu (sesja 20, decyzja 1): czynność,
    // nie nazwa ekranu. `autopilot.title` zostaje tytułem dialogu.
    create: 'Utwórz kampanię',
    activate: 'Uruchom',
    cancel: 'Anuluj',
  },
  // Toasty i potwierdzenia szczegółu (artboard 13).
  toast: {
    paused: 'Wstrzymano · {n} postów czeka',
    paused_one: 'Wstrzymano · {n} post czeka',
    paused_few: 'Wstrzymano · {n} posty czekają',
    paused_many: 'Wstrzymano · {n} postów czeka',
    resumed: 'Wznowiono',
    retried: 'Ponowiono post · -{n} tokeny',
    retried_one: 'Ponowiono post · -{n} token',
    retried_few: 'Ponowiono post · -{n} tokeny',
    retried_many: 'Ponowiono post · -{n} tokenów',
    activated: 'Kampania uruchomiona',
    removedFromPlan: 'Usunięto z planu · +{n} tokeny',
    removedFromPlan_one: 'Usunięto z planu · +{n} token',
    removedFromPlan_few: 'Usunięto z planu · +{n} tokeny',
    removedFromPlan_many: 'Usunięto z planu · +{n} tokenów',
    cancelItemTitle: 'Usunąć z planu?',
    cancelItemBody: 'Ten post nie wyjdzie. Jeśli był już opłacony, tokeny wracają do Twojej puli.',
    cancelItemRefund: 'Tokeny wrócą',
    retryItemTitle: 'Ponowić post?',
    retryItemBody: 'Post trafi z powrotem do planu na najbliższy wolny termin.',
    retryItemCost: 'Koszt ponowienia',
  },
  item: {
    retry: 'Ponów',
    retryLabel: 'Ponów · {n} tokeny',
    retryLabel_one: 'Ponów · {n} token',
    retryLabel_few: 'Ponów · {n} tokeny',
    retryLabel_many: 'Ponów · {n} tokenów',
    cancel: 'Usuń z planu',
    openPost: 'Otwórz post',
    scheduledFor: 'Wyjdzie {when}',
    publishedAt: 'Wyszedł {time}',
    publishingNow: 'Wychodzi teraz',
    tomorrowAt: 'jutro {time}',
    noThumb: 'bez kadru',
    retryCost: 'Ponowienie kosztuje 2 tokeny',
    fixText: 'Popraw tekst',
    fixPrivacy: 'Popraw widoczność',
    gemsHeld: 'tokeny wstrzymane',
    nothingCharged: 'nic nie pobraliśmy',
    refunded: 'tokeny wróciły',
  },
  // Powód, nie surowy kod. Te teksty tłumaczą `publish_job.error_class` / `terminal_reason`
  // na zdanie, które użytkownik rozumie — i które mówi, czy stracił pieniądze.
  // Powody odroczenia dostają czas z `scheduled_at` pozycji po przełożeniu.
  reason: {
    consent_missing: 'Czeka na Twoje potwierdzenie',
    daily_cap: 'Przesunięty - to konto ma już dziś 5 postów. Wyjdzie {when}.',
    min_gap: 'Przesunięty - posty na jednym koncie dzieli co najmniej godzina. Wyjdzie {when}.',
    past_due: 'Wstrzymany - czeka na opłacenie faktury',
    connection_expired: 'Wstrzymany - połącz to konto ponownie',
    connection_suspended: 'Wstrzymany - Twój plan nie obejmuje już tego konta',
    privacy_unavailable: 'Wstrzymany - wybrana widoczność nie jest już dostępna dla tego konta',
    platform_cap: 'Przesunięty na jutro - dzienny limit {platformGen} dla tego konta. Wyjdzie {when}.',
    rate_limited: 'Przesunięty - {platform} poprosił nas o zwolnienie tempa. Wyjdzie {when}.',
    auth_removed: 'Wstrzymany - dostęp do tego konta został cofnięty',
    provider_timeout: 'Nie wyszedł - brak odpowiedzi przez 24 h. Tokeny wróciły.',
    content_gate: 'Zablokowany - tekst wymaga poprawki, zanim post wyjdzie',
    provider_quota: 'Przesunięty - jesteśmy chwilowo na granicy naszej przepustowości. Wyjdzie {when}.',
    // Sufit rozmiaru pliku u NASZEGO partnera publikującego, nie w TikToku (P02).
    render_too_large: 'Za duży plik - nasz partner publikujący ma limit rozmiaru. Nic nie pobraliśmy z Twoich tokenów; krótszy edit powinien przejść.',
    // D-020: post ZOSTAŁ już przekazany partnerowi, a partner odmówił wycofania.
    // Gemy są WSTRZYMANE, nie zwrócone i nie zabrane: rozliczamy to ręcznie.
    withdrawal_failed: 'Nie udało się wycofać - post został już przekazany. Tokeny wstrzymane do wyjaśnienia; odezwiemy się.',
    // Operator wyłączył publikowanie. Post CZEKA — nie przepadł — i nic nie pobraliśmy.
    feature_disabled: 'Wstrzymany - publikowanie jest chwilowo wyłączone. Post czeka, nic nie pobraliśmy.',
    // Doba odroczeń minęła (`dispatcher._defer`/`_hold` → `{reason}_expired`): post nie wyszedł, tokeny wróciły.
    deferral_expired: 'Nie wyszedł - przez dobę nie dało się go zmieścić. Tokeny wróciły.',
    // Fallback dla KAŻDEJ nieznanej klasy błędu — nigdy surowy kod dostawcy.
    unknown: 'Wstrzymany - sprawdzamy, co się stało.',
  },
  refunded: 'Tokeny zwrócone',
  // Błąd wczytania: jedno zdanie, droga naprawy, kod (reguła 8 języka).
  loadError: {
    planner: 'Nie udało się wczytać Planera.',
    plan: 'Nie udało się wczytać planu.',
  },
  // Okno płatnej akcji przy zbyt niskim saldzie: bez zdań, sama tabela liczb.
  noTokens: {
    title: 'Za mało tokenów',
    topup: 'Doładuj tokeny',
  },
  // 45-B (C0): poddrzewa k45 / h45 / p45 z plikow paczek PK / PH / PP2.
  ...appCampaignsK45,
  ...appCampaignsH45,
  ...appCampaignsP45,
}
